import { jsx as c } from "react/jsx-runtime";
import "react";
var o = (r) => /* @__PURE__ */ c("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 36 36",
  ...r,
  children: /* @__PURE__ */ c("path", {
    fill: "currentColor",
    d: "M13.8 17.6c3.5 0 6.3-2.8 6.3-6.3S17.3 5 13.8 5s-6.3 2.8-6.3 6.3 2.8 6.3 6.3 6.3Zm0-9.8c1.96 0 3.5 1.54 3.5 3.5s-1.54 3.5-3.5 3.5-3.5-1.54-3.5-3.5 1.54-3.5 3.5-3.5ZM25 17.6c2.38 0 4.2-1.82 4.2-4.2S27.38 9.2 25 9.2s-4.2 1.82-4.2 4.2 1.82 4.2 4.2 4.2Zm0-5.6c.84 0 1.4.56 1.4 1.4 0 .84-.56 1.4-1.4 1.4-.84 0-1.4-.56-1.4-1.4 0-.84.56-1.4 1.4-1.4Zm-8.26 7h-5.88C7.08 19 4 22.08 4 25.86v2.52c0 .98.84 1.82 1.82 1.82h15.82c.98 0 1.82-.84 1.82-1.82v-2.52c.14-3.78-2.94-6.86-6.72-6.86Zm4.06 8.4h-14v-1.54c0-2.24 1.82-4.06 4.06-4.06h5.88c2.24 0 4.06 1.82 4.06 4.06v1.54Zm6.16-8.4h-3.92c-.42 0-.98.14-1.4.28.98.7 1.68 1.54 2.24 2.52h3.08c1.26 0 2.24.98 2.24 2.24v.56h-4.34c0 .42.14.84.14 1.26v1.54h5.32c.98 0 1.68-.84 1.68-1.68v-1.68c0-2.8-2.24-5.04-5.04-5.04Z"
  })
});
export {
  o as default
};
